import React, {Component, Fragment} from "react"
import {MutationFn} from "react-apollo"

import ModerateRecognitionMutation from "@irati/recognition/apollo/mutation/Recognition/Moderate"
import {RecognitionTypeEdit} from "@irati/recognition/enums/Moderation"
import {Recognition} from "@irati/types"
import ArchiveRecognitionMutation from "@irati/recognition/apollo/mutation/Recognition/Archive"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {Body} from "@irati/ui/src/Typography"

import Actions from "../Recognition/Actions"
import UpdateRecognition from "../Recognition/UpdateRecognition"
import ModeratedMessage from "../../shared/Moderated"
import {ActionsWrapper, ConfirmRemoveRecognition, ConfirmArchiveRecognition} from "./styled"

interface Props {
  recognition: Recognition
  onArchive: () => void
}

interface State {
  editMode: string | null
}

class ModeratedRecognitionMessage extends Component<Props> {
  state: State = {
    editMode: null
  }

  enableUpdateMode = () => {
    this.setState({editMode: RecognitionTypeEdit.UPDATE})
  }

  enableModerateMode = () => {
    this.setState({editMode: RecognitionTypeEdit.MODERATE})
  }

  enableArchiveMode = () => {
    this.setState({editMode: RecognitionTypeEdit.ARCHIVE})
  }

  disableEditMode = () => {
    this.setState({editMode: null})
  }

  render() {
    const {recognition, onArchive} = this.props
    const {editMode} = this.state

    const isUpdateMode = editMode === RecognitionTypeEdit.UPDATE
    const isModerateMode = editMode === RecognitionTypeEdit.MODERATE
    const isArchiving = editMode === RecognitionTypeEdit.ARCHIVE

    return (
      <Fragment>
        <ActionsWrapper>
          <Actions
            pullRight
            disabled={isUpdateMode || isModerateMode}
            recognition={recognition}
            onClickEdit={this.enableUpdateMode}
            onClickRemove={this.enableModerateMode}
            onClickArchive={this.enableArchiveMode}
          />
          {isArchiving && (
            <ArchiveRecognitionMutation recognition={recognition} onCompleted={onArchive}>
              {(mutate: MutationFn, apolloState: ApolloState) => (
                <ConfirmArchiveRecognition onCancel={this.disableEditMode} onConfirm={mutate} apolloState={apolloState} />
              )}
            </ArchiveRecognitionMutation>
          )}
          {isModerateMode && (
            <ModerateRecognitionMutation recognition={recognition} onCompleted={this.disableEditMode}>
              {(mutate: MutationFn) => <ConfirmRemoveRecognition onCancel={this.disableEditMode} onConfirm={mutate} />}
            </ModerateRecognitionMutation>
          )}
        </ActionsWrapper>
        {isUpdateMode ? (
          <UpdateRecognition recognition={recognition} onUpdateSuccess={this.disableEditMode} onClickCancel={this.disableEditMode} />
        ) : (
          <Body small marginBottom={1} wordBreak="break-word">
            <ModeratedMessage message={recognition.message} isModerated={recognition.moderated} />
          </Body>
        )}
      </Fragment>
    )
  }
}

export default ModeratedRecognitionMessage
